import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as dms from '../../../../../../dms'
import * as organizations from '../../../../../organizations'
import { CLUSTER_ASSIGNMENT_OPTIONS_GROUP_ID } from '../constants'
import type { Plugin } from '../plugin'

const CLUSTER_ASSIGNMENT_OPTIONS_GROUP_NAME = 'Cluster Assignment Options'

/**
 * Sets the cluster options group for the active record assignment workflow.
 */
export const setClusterAssignmentOptionsGroup = store.effects.create(
  (
    feature: Plugin['feature'],
    plugin: Plugin,
    schemaFeature: dms.schema.Feature,
  ) =>
    feature.actions.initiate.success.observe().pipe(
      rxjs.withLatestFrom(
        feature.selectors.assignmentRecords.asObservable,
        schemaFeature.selectors.schema.asObservable,
      ),
      rxjs.map(([action, records, schema]) => {
        const leafOrgEntity = schema.tryGetLeafEntityOf(
          organizations.constants.DIMENSION_ID,
        )
        const occupierIds = new Set(records.map(record => record.occupierId))

        // Cluster options are scoped by occupier, so mixed-occupier workflows
        // cannot produce one valid options group.
        if (occupierIds.size !== 1) {
          return store.effects.SKIP
        }
        const [occupierId] = [...occupierIds]

        // TODO: Replace this client-side group predicate with a backend-backed
        // clusters organization filter, likely through GraphQL/controller
        // filter support, so the modal can load clusters by organization.
        // Multi-record assignment intentionally exposes options only when every
        // selected record has the same occupier, because cluster options are
        // scoped by it.
        return plugin.clustersEc.plugins.groupPlugin.feature.actions.put
          .from(action)
          .create({
            group: {
              entitySelector: {
                predicate: cluster =>
                  !!leafOrgEntity &&
                  !!occupierId &&
                  cluster.organization?.[leafOrgEntity.id] === occupierId,
              },
              id: CLUSTER_ASSIGNMENT_OPTIONS_GROUP_ID,
              name: CLUSTER_ASSIGNMENT_OPTIONS_GROUP_NAME,
            },
          })
      }),
    ),
)
